import { ContentTileModel } from '@_types/organisms';
import Picture from '@atoms/pictures/Picture';
import Icon from '@atoms/icons/Icon';
import { getModifiers } from '@helpers/functions';

const ContentTile = (model: ContentTileModel) => {
  const { title, image, newsText, readMoreText, description, url, icon } = model;
  const styleModifier = getModifiers(model, 'kf-o-content-tile');

  return (
    <div className={`kf-o-content-tile ${styleModifier}`}>
      <div className="kf-o-content-tile__inner">
        {image && <div className="kf-o-content-tile__preview-image">{image && <Picture {...image} />}</div>}
        {icon && (
          <div className="kf-o-content-tile__icon">
            <Picture {...icon} />
          </div>
        )}
        <div className="kf-o-content-tile__preview-content">
          {newsText && <p className="kf-o-content-tile__news-tag">{newsText}</p>}
          <h3>
            <a className="kf-o-content-tile__title" href={url}>
              {title}
            </a>
          </h3>

          <p className="kf-o-content-tile__description">{description}</p>
          {readMoreText && (
            <p className="kf-o-content-tile__read-more">
              <Icon iconPath="#kf-arrow-forward" viewBoxHeight={24} viewBoxWidth={24} />
              <span>{readMoreText}</span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContentTile;
